/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Performs right-to-left function composition.
 * The rightmost function may take in any number of args (have any arity),
 * the remaining functions must only take one argument (unary).
 * @param funcs - list of functions to compose.
 */
export const compose = (...funcs: Function[]): Function =>
  funcs.reduce((f, g) => (...args: any[]): any => f(g(...args)));

/**
 * Takes in a predicate function,
 * returns a function that will filter an array based on that predicate.
 * @param pred - filtering function applied to each array element.
 */
export const filter = (pred: (...args: any) => boolean): Function => (arr: any[]): any[] =>
  arr.filter(pred);
